// extracted by mini-css-extract-plugin
export default {"userSATPracticePage":"userSATPracticePage_userSATPracticePage__vjK2V","userTestCategory":"userSATPracticePage_userTestCategory__FSMTq"};